'use client';

import Link from 'next/link';

interface HomeNetworkSectionProps {
  onCategoryChange: (cat: string) => void;
}

const NETWORK_ITEMS = [
  {
    label: 'ViddStarTV',
    tag: 'Main Platform',
    desc: 'The home of raw, real, and unfiltered video content. User-submitted, community-driven.',
    href: '/',
    icon: 'M12 4v16m8-8H4',
    active: true,
  },
  {
    label: 'ViddStar Clips',
    tag: 'Short & Viral',
    desc: 'The fastest, funniest, and most viral short clips on the internet.',
    href: '/clips',
    icon: 'M7 4v16M17 4v16M3 8h4m10 0h4M3 16h4m10 0h4M4 20h16a1 1 0 001-1V5a1 1 0 00-1-1H4a1 1 0 00-1 1v14a1 1 0 001 1z',
    active: false,
  },
  {
    label: 'ViddStar News',
    tag: 'Commentary & Blogs',
    desc: 'In-depth commentary, breaking stories, and editorial takes on what matters.',
    href: '/news',
    icon: 'M19 20H5a2 2 0 00-2 2V6a2 2 0 002-2h10a2 2 0 002 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z',
    active: false,
  },
  {
    label: 'ViddStar Exclusive',
    tag: '★ Original Content',
    desc: 'ViddStar originals — produced and curated exclusively here. No reposts.',
    href: '/exclusive',
    icon: 'M11.049 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zM12 2a10 10 0 100 20 10 10 0 000-20z',
    active: false,
  },
];

export default function HomeNetworkSection({ onCategoryChange }: HomeNetworkSectionProps) {
  return (
    <div className="mt-8 mb-2">
      <div className="flex items-baseline gap-2 border-b border-stroke-primary pb-3 mb-5">
        <span className="text-text-primary text-2xl md:text-3xl font-normal">THE</span>
        <span className="text-brand-red font-bold text-2xl md:text-3xl">VIDDSTAR NETWORK</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {NETWORK_ITEMS.map(item => (
          <Link
            key={item.label}
            href={item.href}
            className={`group border transition-colors duration-200 p-5 flex flex-col gap-3 ${
              item.active ? 'border-brand-red bg-surface-secondary' : 'border-stroke-primary bg-surface-secondary hover:border-brand-red'
            }`}
          >
            <div className="flex items-center justify-between">
              <div className={`w-10 h-10 rounded-[4px] flex items-center justify-center flex-shrink-0 transition-colors duration-200 ${
                item.active ? 'bg-brand-red' : 'bg-surface-tertiary group-hover:bg-brand-red'
              }`}>
                <svg className={`w-5 h-5 transition-colors duration-200 ${item.active ? 'text-white' : 'text-text-secondary group-hover:text-white'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d={item.icon} />
                </svg>
              </div>
              {item.active && (
                <span className="text-xs font-bold uppercase text-brand-red border border-brand-red px-1.5 py-0.5 rounded-[2px]">Live</span>
              )}
            </div>
            <div>
              <h3 className={`font-bold text-sm uppercase tracking-wide transition-colors duration-150 ${item.active ? 'text-brand-red' : 'text-text-primary group-hover:text-brand-red'}`}>{item.label}</h3>
              <p className="text-text-muted text-xs mt-0.5 mb-2">{item.tag}</p>
              <p className="text-text-secondary text-xs leading-relaxed">{item.desc}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
